import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=e4f4be18&"
import script from "./TrainingView.vue?vue&type=script&lang=js&"
export * from "./TrainingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports